import Box from '@mui/material/Box';

/** Official payment method logos — assets live in public/images/logo/ */
export const PAYMENT_LOGO_SRC = {
  esewa: '/images/logo/esewa_logo.png',
  khalti: '/images/logo/khalti_logo.png',
  connectips: 'https://connectips.com/images/logo_connectIPS.png',
  fonepay: '/images/logo/fonepay_logo.svg',
} as const;

export function PaymentLogoImage({
  src,
  alt,
  height = 28,
}: {
  src: string;
  alt: string;
  height?: number;
}) {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        height,
        maxWidth: '100%',
        width: 'auto',
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
}
